export const IncidentReportsPageTabs = {
  TABLE: 'ir_table',
  MONTHLY: 'ir_monthly',
}